// extracted by mini-css-extract-plugin
module.exports = {"ItemImage":"index-module--ItemImage--PYeuw"};